import { Background, Spacing } from "@bonusx-global/bx-design-system";
import { PREVIOUS_URL_PATH } from "../../../../../constants/env";
import type { IHeaderV2Store } from "../../../../../legacy/components/HeaderV2/stores/header-v2-store";
import { headerHeight } from "../../../../../R";
import type { ILayoutStylesStore } from "../../../../../types/layout/layout-styles.type";
import type { IRouteWrapperVariant } from "../../../../../types/layout/route-wrapper-variant.interface";

export class FullScreenWithCloseButtonRouteWrapperVariant implements IRouteWrapperVariant {
  get sidebarAvailable(): boolean {
    return false;
  }
  get headerAvailable(): boolean {
    return true;
  }
  get bottomNavigationAvailable(): boolean {
    return false;
  }

  get layoutStyles(): ILayoutStylesStore {
    return {
      layoutStyles: {
        mobile: {
          backgroundColor: Background.paper,
          "& .MuiAppBar-root": { backgroundColor: "transparent" },
          "& .MuiToolbar-root": { borderBottom: "none" },
        },
        desktop: {
          backgroundColor: Background.paper,
          height: "100vh !important",
          "& .MuiAppBar-root": { backgroundColor: "transparent" },
          "& .MuiToolbar-root": {
            borderBottom: "none",
            minHeight: `${Spacing["4000"]} !important`,
            padding: `${Spacing["750"]} ${Spacing["3000"]}`,
          },
        },
      },
      contentLayoutStyles: {
        mobile: {
          height: `calc(100vh - ${headerHeight})`,
        },
        desktop: {
          padding: "0px!important",
        },
      },
    };
  }

  get titleAvailable(): boolean {
    return false;
  }

  getVariantHeaderSettings(): IHeaderV2Store {
    return {
      layoutStore: {
        closeButton: { url: PREVIOUS_URL_PATH },
        showLogo: false,
        showLogoOnMobile: false,
        forceLogoExtended: false,
      },
    };
  }
}
